export default __webpack_public_path__ + "static/media/12.45d0d50e.JPG";